// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.js2HNyCvVd_CQpt2sDGA {
	align-items: center;
	background-color: rgba(23, 24, 27, 0.6);
	display: flex;
	justify-content: center;
	z-index: 100;
}
.XwutuzZRWTkRvcZY1eJW {
	display: flex;
	margin: 0;
	padding: 0;
	position: relative;
}
@media not screen and (max-width: 767px) {
.XwutuzZRWTkRvcZY1eJW {
		border-radius: 12px;
		width: 445px;
}
	}
@media (max-width: 767px) {
.XwutuzZRWTkRvcZY1eJW {
		align-self: flex-end;
		border-top-left-radius: 24px;
		border-top-right-radius: 24px;
		width: 100vw;
}
	}
.iLLakif4ugfoqW1IlAx_ {
	display: flex;
	flex-direction: column;
	flex: 1;
	max-height: 100vh;
	overflow-y: scroll;
	padding: 24px;
}
.GWvTgXf5DujQQMyEn3Dv {
	font-size: 24px;
	font-weight: bold;
	line-height: 24px;
	margin-bottom: 48px;
}
.jS72Q2CbRRmwLv3BrVar {
	display: flex;
	flex-direction: column;
}
.jS72Q2CbRRmwLv3BrVar > * {
		margin-bottom: 12px;
	}
.be7qGpbDbOypm8ezVuDb {
	align-items: center;
	background-color: #edf2f8;
	border-radius: 50%;
	border: none;
	cursor: pointer;
	display: flex;
	height: 32px;
	justify-content: center;
	padding: 0;
	position: absolute;
	right: 0;
	top: 0;
	transform: translate(45px, 0px);
	width: 32px;
}
.be7qGpbDbOypm8ezVuDb > svg {
		width: 18px;
		color: #9ca6b4;
	}
.be7qGpbDbOypm8ezVuDb:hover {
		background-color: #2d2d2d;
	}
.be7qGpbDbOypm8ezVuDb:hover > svg {
			color: #fff;
		}
@media (max-width: 767px) {
.be7qGpbDbOypm8ezVuDb {
		background-color: transparent;
		transform: translate(-15px, 15px);
}
	}
.bOn7rwpMzqvdo3aG6Cqt {
	height: 16px;
	width: 16px;
}
/* Avoid Chrome to see Safari hack */
@supports (-webkit-touch-callout: none) {
	.iLLakif4ugfoqW1IlAx_ {
		/* The hack for Safari */
		height: -webkit-fill-available;
	}
}
`, "",{"version":3,"sources":["webpack://./src/components/ConnectWalletModal/ConnectWalletModal.pcss"],"names":[],"mappings":"AAEA;CACC,mBAAmB;CACnB,uCAAuC;CACvC,aAAa;CACb,uBAAuB;CACvB,YAAY;AACb;AAEA;CACC,aAAa;CACb,SAAS;CACT,UAAU;CACV,kBAAkB;AAanB;AAXC;AAND;EAOE,mBAAmB;EACnB,YAAY;AASd;CARC;AAEA;AAXD;EAYE,oBAAoB;EACpB,4BAA4B;EAC5B,6BAA6B;EAC7B,YAAY;AAEd;CADC;AAGD;CACC,aAAa;CACb,sBAAsB;CACtB,OAAO;CACP,iBAAiB;CACjB,kBAAkB;CAClB,aAAa;AACd;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,iBAAiB;CACjB,mBAAmB;AACpB;AAEA;CACC,aAAa;CACb,sBAAsB;AAKvB;AAHC;EACC,mBAAmB;CACpB;AAGD;CACC,mBAAmB;CACnB,yBAAyB;CACzB,kBAAkB;CAClB,YAAY;CACZ,eAAe;CACf,aAAa;CACb,YAAY;CACZ,uBAAuB;CACvB,UAAU;CACV,kBAAkB;CAClB,QAAQ;CACR,MAAM;CACN,+BAA+B;CAC/B,WAAW;AAmBZ;AAjBC;EACC,WAAW;EACX,cAAc;CACf;AAEA;EACC,yBAAyB;CAK1B;AAHC;GACC,WAAW;EACZ;AAGD;AA7BD;EA8BE,6BAA6B;EAC7B,iCAAiC;AAEnC;CADC;AAGD;CACC,YAAY;CACZ,WAAW;AACZ;AAEA,oCAAoC;AACpC;CACC;EACC,wBAAwB;EACxB,8BAA8B;CAC/B;AACD","sourcesContent":["@import './../../stylesheets/media-queries.pcss';\n\n.overlay {\n\talign-items: center;\n\tbackground-color: rgba(23, 24, 27, 0.6);\n\tdisplay: flex;\n\tjustify-content: center;\n\tz-index: 100;\n}\n\n.container {\n\tdisplay: flex;\n\tmargin: 0;\n\tpadding: 0;\n\tposition: relative;\n\n\t@media not screen and (--mobile) {\n\t\tborder-radius: 12px;\n\t\twidth: 445px;\n\t}\n\n\t@media (--mobile) {\n\t\talign-self: flex-end;\n\t\tborder-top-left-radius: 24px;\n\t\tborder-top-right-radius: 24px;\n\t\twidth: 100vw;\n\t}\n}\n\n.content {\n\tdisplay: flex;\n\tflex-direction: column;\n\tflex: 1;\n\tmax-height: 100vh;\n\toverflow-y: scroll;\n\tpadding: 24px;\n}\n\n.title {\n\tfont-size: 24px;\n\tfont-weight: bold;\n\tline-height: 24px;\n\tmargin-bottom: 48px;\n}\n\n.wallets {\n\tdisplay: flex;\n\tflex-direction: column;\n\n\t& > * {\n\t\tmargin-bottom: 12px;\n\t}\n}\n\n.dismiss {\n\talign-items: center;\n\tbackground-color: #edf2f8;\n\tborder-radius: 50%;\n\tborder: none;\n\tcursor: pointer;\n\tdisplay: flex;\n\theight: 32px;\n\tjustify-content: center;\n\tpadding: 0;\n\tposition: absolute;\n\tright: 0;\n\ttop: 0;\n\ttransform: translate(45px, 0px);\n\twidth: 32px;\n\n\t& > svg {\n\t\twidth: 18px;\n\t\tcolor: #9ca6b4;\n\t}\n\n\t&:hover {\n\t\tbackground-color: #2d2d2d;\n\n\t\t& > svg {\n\t\t\tcolor: #fff;\n\t\t}\n\t}\n\n\t@media (--mobile) {\n\t\tbackground-color: transparent;\n\t\ttransform: translate(-15px, 15px);\n\t}\n}\n\n.cross {\n\theight: 16px;\n\twidth: 16px;\n}\n\n/* Avoid Chrome to see Safari hack */\n@supports (-webkit-touch-callout: none) {\n\t.content {\n\t\t/* The hack for Safari */\n\t\theight: -webkit-fill-available;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `js2HNyCvVd_CQpt2sDGA`,
	"container": `XwutuzZRWTkRvcZY1eJW`,
	"content": `iLLakif4ugfoqW1IlAx_`,
	"title": `GWvTgXf5DujQQMyEn3Dv`,
	"wallets": `jS72Q2CbRRmwLv3BrVar`,
	"dismiss": `be7qGpbDbOypm8ezVuDb`,
	"cross": `bOn7rwpMzqvdo3aG6Cqt`
};
export default ___CSS_LOADER_EXPORT___;
